import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './containers/login/login.component';
import { CreateAccountComponent } from './containers/create-account/create-account.component';
import { VerifyComponent } from './containers/verify/verify.component';
import { ResetPasswordComponent } from './containers/reset-password/reset-password.component';
import { SetPasswordComponent } from './containers/set-password/set-password.component';
import { ShellComponent } from '@app/shell/shell.component';
import { AuthService } from '@app/services/auth.service';
import { GuestOnlyGuard } from '@app/services/guest-only.guard';
import { environment } from '@env/environment';
import {
    RegistrationSuccessfulComponent
} from '@app/user-on-boarding/containers/registration-successful/registration-successful.component';

const routes: Routes = [
    {
        path: 'account',
        component: ShellComponent,
        children: [
            {
                path: 'login', component: LoginComponent, data: { pageHeader: 'Log In' },
                canActivate: [
                    GuestOnlyGuard,
                    () => {
                        if (environment.useUniversalLogin) {
                            const authService = inject(AuthService);
                            authService.login();
                            return false;
                        }

                        return true;
                    }
                ]
            },
            {
                path: 'reset-password', component: ResetPasswordComponent, data: { pageHeader: 'Reset Your Password' }
            },
            {
                path: 'set-password', component: SetPasswordComponent, data: { pageHeader: 'Set New Password' }
            },
            {
                path: 'create', component: CreateAccountComponent, data: { pageHeader: 'Register' },
                canActivate: [GuestOnlyGuard]
            },
            {
                path: 'verify', component: VerifyComponent, data: {
                    pageHeader: 'Verify Your Account',
                    hideHeaderForReverification: true
                }
            },
            {
                path: 'registration-successful', component: RegistrationSuccessfulComponent, data: { pageHeader: 'Registration Successful' }
            }
        ],
        data: { reuse: true }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserOnBoardingRoutingModule { }
